export const ENTITY_PARTNER = {value: 'partner', label: 'Partner'};
export const ENTITY_PARTNER_FACILITY = {value: 'partner_facility', label: 'Placówka partnera'};

export const ENTITY_OFWCA = {value: 'ofwca', label: 'OFWCA'};
export const ENTITY_OFWCA_MEETING = {value: 'ofwca_meeting', label: 'OFWCA Spotkanie'};

export const ENTITY_SALES_PROFILE = {value: 'sales_profile', label: 'Profil sprzedaży'};
export const ENTITY_FACILITY_VERIFICATION_SALES_PROCESS =
  {value: 'FacilityVerificationSalesProcess', label: 'Weryfikacja procesu sprzedaży placówki'};
export const ENTITY_AFFILIATE_LINK_ID = {value: 'affiliate_link_id', label: 'Link afiliacyjny'};

export const ENTITY_CONTRACT = {value: 'contract', label: 'Umowa'};
export const ENTITY_CONTRACT_INSURANCE_COMPANY = {value: 'contract_insurance_company', label: 'Umowa z towarzystwem ubezpieczeniowym'};

export const ENTITY_COMMISSION_ANNEX = {value: 'commission_annex', label: 'Aneks prowizyjny'};
export const ENTITY_COMMISSION_ANNEX_GROUP = {value: 'commission_annex_group', label: 'Grupa w aneksie prowizyjnym'};
export const ENTITY_COMMISSION_ANNEX_RISK = {value: 'commission_annex_risk', label: 'Ryzyko w aneksie prowizyjnym'};
export const ENTITY_COMMISSION_ANNEX_THRESHOLD = {value: 'commission_annex_threshold', label: 'Próg w aneksie prowizyjnym'};
export const ENTITY_COMMISSION_CONTRACT_SETTLEMENT = {value: 'commission_contract_settlement', label: 'Rozliczenie prowizji z umowy'};
export const ENTITY_COMMISSION_IMPORT = {value: 'commission_import', label: 'Prowizja'};
export const ENTITY_COMMISSION_IMPORT_ROW = {value: 'commission_import_row', label: 'Pozycja importu prowizji'};
export const ENTITY_COMMISSION_JOB = {value: 'commission_job', label: 'Naliczanie prowizji'};
export const ENTITY_COMMISSION_MARGIN_REPORT = {value: 'commission_margin_report', label: 'Raport marży prowizyjnej'};
export const ENTITY_COMMISSION_REDIRECTION = {value: 'commission_redirection', label: 'Przepięcie polis'};
export const ENTITY_COMMISSION_REDIRECTION_IMPORT = {value: 'commission_redirection_import', label: 'Import przepięć polis'};
export const ENTITY_COMMISSION_UPDATE_PACKAGE = {value: 'commission_update_package', label: 'Pakiet konfiguracji prowizji'};

export const ENTITY_SETTLEMENT_TEMPLATE = {value: 'settlement_template', label: 'Szablon rozliczenia'};

export const ENTITY_RISK = {value: 'risk', label: 'Ryzyko'};
export const ENTITY_RISK_CONFIGURATION = {value: 'risk_configuration', label: 'Konfiguracja ryzyka'};
export const ENTITY_RISK_DICTIONARY = {value: 'risk_dictionary', label: 'Słownik ryzyka'};
export const ENTITY_RISK_DICTIONARY_RISK = {value: 'risk_dictionary_risk', label: 'Konfiguracja słownika ryzyka'};
export const ENTITY_RISK_GROUP = {value: 'risk_group', label: 'Grupa ryzyka'};
export const ENTITY_RISK_RATE = {value: 'risk_rate', label: 'Stawka ryzyka'};

export const ENTITY_THRESHOLD_DICTIONARY = {value: 'threshold_dictionary', label: 'Słownik progów'};
export const ENTITY_THRESHOLD_DICTIONARY_GROUP = {value: 'threshold_dictionary_group', label: 'Grupa słowników progów'};
export const ENTITY_THRESHOLD_DICTIONARY_GROUP_RISK =
  {value: 'threshold_dictionary_group_risk', label: 'Ryzyko w grupie progów'};

export const ENTITY_DOCUMENT = {value: 'document', label: 'Dokument'};
export const ENTITY_INVOICE = {value: 'invoice', label: 'Faktura'};
export const ENTITY_INVOICE_DOCUMENT = {value: 'invoice_document', label: 'Faktura dokument'};
export const ENTITY_SELF_BILLING_FORM = {value: 'SelfBillingForm', label: 'Formularz samofakturowania'};
export const ENTITY_BANK_FILES = {value: 'bank_files', label: 'Pliki bankowe'};

export const ENTITY_RECEIVABLES_IMPORT = {value: 'receivables_import', label: 'Należność'};
export const ENTITY_RECEIVABLES_PAYMENT_IMPORT = {value: 'receivables_payment_import', label: 'Wpłata należności'};
export const ENTITY_RECEIVABLES_STATEMENT = {value: 'receivables_statement', label: 'Zestawienie należności'};
export const ENTITY_RECEIVABLES_TRANSFER = {value: 'receivables_transfer', label: 'Przelew należności'};

export const ENTITY_REGISTRATION = {value: 'registration', label: 'Rejestracja'};
export const ENTITY_REGISTRATION_ID = {value: 'registration_id', label: 'Identyfikator rejestracji'};
export const ENTITY_DEREGISTRATION_PACK = {value: 'deregistration_pack', label: 'Pakiet wyrejestrowań'};
export const ENTITY_KRK = {value: 'krk', label: 'KRK'};
export const ENTITY_IDD_TRAINING_CERTIFICATE = {value: 'idd_training_certificate', label: 'Zaświadczenie szkolenia IDD'};
export const ENTITY_PERSONAL_DATA_CHANGE = {value: 'personal_data_change', label: 'Zmiana danych osobowych'};
export const ENTITY_BLOCKED_NIP = {value: 'blocked_nip', label: 'Zablokowany NIP'};

export const ENTITY_TERMINALS = {value: 'terminals', label: 'Terminale'};
export const ENTITY_TERMINALS_IMPORT = {value: 'terminals_import', label: 'Terminal transakcje'};

export const ENTITY_TEMPLATE = {value: 'template', label: 'Szablon'};

export const ENTITY_MEETING = {value: 'meeting', label: 'Wydarzenie'};
export const ENTITY_DYNAMIC_DICTIONARY = {value: 'dynamic_dictionary', label: 'Słownik dynamiczny'};
export const ENTITY_NOTE = {value: 'note', label: 'Notatka'};

export const ENTITY_TYPES = [ENTITY_PARTNER, ENTITY_PARTNER_FACILITY, ENTITY_OFWCA, ENTITY_OFWCA_MEETING,
  ENTITY_SALES_PROFILE, ENTITY_FACILITY_VERIFICATION_SALES_PROCESS, ENTITY_AFFILIATE_LINK_ID, ENTITY_CONTRACT,
  ENTITY_CONTRACT_INSURANCE_COMPANY, ENTITY_COMMISSION_ANNEX, ENTITY_COMMISSION_ANNEX_GROUP, ENTITY_COMMISSION_ANNEX_RISK,
  ENTITY_COMMISSION_ANNEX_THRESHOLD, ENTITY_COMMISSION_CONTRACT_SETTLEMENT, ENTITY_COMMISSION_IMPORT, ENTITY_COMMISSION_IMPORT_ROW,
  ENTITY_COMMISSION_JOB, ENTITY_COMMISSION_MARGIN_REPORT, ENTITY_COMMISSION_REDIRECTION, ENTITY_COMMISSION_REDIRECTION_IMPORT,
  ENTITY_COMMISSION_UPDATE_PACKAGE, ENTITY_SETTLEMENT_TEMPLATE, ENTITY_RISK, ENTITY_RISK_CONFIGURATION, ENTITY_RISK_DICTIONARY,
  ENTITY_RISK_DICTIONARY_RISK, ENTITY_RISK_GROUP, ENTITY_RISK_RATE, ENTITY_THRESHOLD_DICTIONARY, ENTITY_THRESHOLD_DICTIONARY_GROUP,
  ENTITY_THRESHOLD_DICTIONARY_GROUP_RISK, ENTITY_DOCUMENT, ENTITY_INVOICE, ENTITY_INVOICE_DOCUMENT, ENTITY_SELF_BILLING_FORM,
  ENTITY_BANK_FILES, ENTITY_RECEIVABLES_IMPORT, ENTITY_RECEIVABLES_PAYMENT_IMPORT, ENTITY_RECEIVABLES_STATEMENT,
  ENTITY_RECEIVABLES_TRANSFER, ENTITY_REGISTRATION, ENTITY_REGISTRATION_ID, ENTITY_DEREGISTRATION_PACK, ENTITY_KRK,
  ENTITY_IDD_TRAINING_CERTIFICATE, ENTITY_PERSONAL_DATA_CHANGE, ENTITY_BLOCKED_NIP, ENTITY_TERMINALS, ENTITY_TERMINALS_IMPORT,
  ENTITY_TEMPLATE, ENTITY_MEETING, ENTITY_DYNAMIC_DICTIONARY, ENTITY_NOTE
].sort((a, b) => a.label.localeCompare(b.label));

export const SOFT_DELETED_ENTITY = [
  ENTITY_PARTNER, ENTITY_PARTNER_FACILITY, ENTITY_OFWCA, ENTITY_CONTRACT, ENTITY_COMMISSION_ANNEX, ENTITY_COMMISSION_ANNEX_RISK,
  ENTITY_RISK_CONFIGURATION, ENTITY_RISK_DICTIONARY, ENTITY_DOCUMENT, ENTITY_REGISTRATION, ENTITY_REGISTRATION_ID,
  ENTITY_DEREGISTRATION_PACK, ENTITY_KRK, ENTITY_PERSONAL_DATA_CHANGE, ENTITY_MEETING, ENTITY_DYNAMIC_DICTIONARY
];
